import { useTranslation } from 'react-i18next';
import { SafeAreaView, ScrollView, SxProp, View } from 'dripsy';
import ReactNative from 'react-native';

import { MyEarnings, MyEarningsProps } from './myEarnings/MyEarnings';
import { Overview, OverviewProps } from './overview/Overview';
import { PageContainer } from '../../components/page/PageContainer';
import { PageItem } from '../../components/page/PageItem';
import { Positions, PositionsProps } from '../../components/positions/Positions.web';
import { PageHeader } from '../page/PageHeader';
import { EarnTabRoutes } from '../..';
import { useEarnPageNavigator } from '../../utils/useEarnPageNavigator';
import { useAsyncStorage } from '@/devtools/hooks/useAsyncStorage';
import React, { useState } from 'react';

interface PortfolioWebProps {
  overviewProps: OverviewProps;
  positionsProps: PositionsProps;
  myEarningsProps: MyEarningsProps;
  layoutStyle: {
    isRow: boolean;
    isColumn: boolean;
  };
}

export const PortfolioWeb: React.FC<PortfolioWebProps> = ({ overviewProps, positionsProps, myEarningsProps, layoutStyle }) => {
  const { t } = useTranslation();
  const { data } = useEarnPageNavigator();

  const { value: showAmount, set: setShowAmount } = useAsyncStorage<boolean>('showAmount');
  const toggleShowAmount = (value: boolean) => {
    setShowAmount(value);
  };

  const [overviewDimensions, setOverviewDimensions] = useState({ width: 0, height: 0 });
  const onOverviewLayout = (event: ReactNative.LayoutChangeEvent) => {
    const { width, height } = event.nativeEvent.layout;
    setOverviewDimensions({ width, height });
  };

  return (
    <SafeAreaView sx={styles.container}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <PageContainer sx={{ paddingX: '$10', paddingY: '$10', backgroundColor: 'transparent' }}>
          <PageHeader data={data} currentPage={EarnTabRoutes.Portfolio} title={t('earn-invest::glossary.earn-and-invest')} />
          {/* <Divider /> */}
          <View sx={{ gap: '$5' }}>
            <View sx={{ gap: '$5', flexDirection: layoutStyle.isRow ? 'row' : 'column' }}>
              <PageItem sx={styles.pageItem} onLayout={onOverviewLayout}>
                <Overview {...overviewProps} showAmount={!!showAmount} toggleShowAmount={toggleShowAmount} />
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, flex: 1, height: overviewDimensions.height, maxHeight: overviewDimensions.height }}>
                <MyEarnings {...myEarningsProps} showAmount={!!showAmount} />
              </PageItem>
            </View>
            <View sx={{ flex: 1, gap: '$5', width: '100%' }}>
              <PageItem sx={styles.pageItem}>
                <Positions {...positionsProps} showAmount={!!showAmount} />
              </PageItem>
            </View>
          </View>
        </PageContainer>
      </ScrollView>
    </SafeAreaView>
  );
};

enum StyleName {
  container = 'container',
  topRow = 'topRow',
  topCol = 'topCol',
  pageHeader = 'pageHeader',
  pageItem = 'pageItem'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flex: 1,
    backgroundColor: 'transparent'
  },
  topRow: {
    flexDirection: 'row',
    gap: '$5'
  },
  topCol: {
    // display: 'block',
    gap: '$5'
  },
  pageHeader: {
    mb: '$6'
  },
  pageItem: { height: 'fit-content', padding: '$7', borderRadius: 15, backgroundColor: '$backgroundPrimary' }
};
